;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { useEffect, useState } from 'react';
import { MdCheckCircle, MdWarning } from 'react-icons/md';
import { Alert } from 'reactstrap';
import { getI18nUtils } from 'shared/i18n/i18n-utils';
import { Dictionaries } from '../../i18n/i18n-config';

type FormAlertProps = {
  type: 'warning' | 'success' | 'danger';
  message: string;
};

type Props = {
  alert: FormAlertProps | null;
  className?: string;
  dictionary: Partial<Dictionaries>;
};

function FormAlert({ alert, className, dictionary }: Props) {
  const [alertState, setAlertState] = useState<FormAlertProps | null>(alert);
  const { formatMessage } = getI18nUtils(dictionary);

  useEffect(() => {
    if (!alert) return;
    setAlertState(alert);
    const timer = setTimeout(() => setAlertState(null), 3000);
    return () => clearTimeout(timer);
  }, [alert]);

  if (!alertState) return null;

  return (
    <Alert
      color={alertState.type}
      isOpen={!!alertState}
      toggle={() => setAlertState(null)}
      className={`d-flex align-items-start align-items-sm-center ${className || ''}`}
    >
      {(() => {
        switch (alertState.type) {
          case 'success':
            return <MdCheckCircle size={22} className="me-2" />;
          case 'warning':
          case 'danger':
            return <MdWarning size={22} className="me-2" />;
          default:
            break;
        }
      })()}
      {formatMessage({ id: alertState.message })}
    </Alert>
  );
}

export default FormAlert;
